import {
  WS_EIGHT_WEEKS,
  WS_ELEVEN_WEEKS,
  WS_FIVE_WEEKS,
  WS_FOUR_WEEKS,
  WS_NINE_WEEKS,
  WS_ONE_DAY,
  WS_ONE_WEEK,
  WS_SEVEN_WEEKS,
  WS_SIX_WEEKS,
  WS_TEN_WEEKS,
  WS_THREE_WEEKS,
  WS_TWELVE_WEEKS,
  WS_TWO_WEEKS,
} from '@pages/WorkSchedule/constants/filters';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const DAYS_IN_WEEK = 7;

export const periodDayCounts: Array<{
  id: NWorkSchedule.Filters['period']['detailedPeriod'];
  daysCount: number;
}> = [
  {
    id: WS_ONE_DAY,
    daysCount: 1,
  },
  {
    id: WS_ONE_WEEK,
    daysCount: DAYS_IN_WEEK,
  },
  {
    id: WS_TWO_WEEKS,
    daysCount: DAYS_IN_WEEK * 2,
  },
  {
    id: WS_THREE_WEEKS,
    daysCount: DAYS_IN_WEEK * 3,
  },
  {
    id: WS_FOUR_WEEKS,
    daysCount: DAYS_IN_WEEK * 4,
  },
  {
    id: WS_FIVE_WEEKS,
    daysCount: DAYS_IN_WEEK * 5,
  },
  {
    id: WS_SIX_WEEKS,
    daysCount: DAYS_IN_WEEK * 6,
  },
  {
    id: WS_SEVEN_WEEKS,
    daysCount: DAYS_IN_WEEK * 7,
  },
  {
    id: WS_EIGHT_WEEKS,
    daysCount: DAYS_IN_WEEK * 8,
  },
  {
    id: WS_NINE_WEEKS,
    daysCount: DAYS_IN_WEEK * 9,
  },
  {
    id: WS_TEN_WEEKS,
    daysCount: DAYS_IN_WEEK * 10,
  },
  {
    id: WS_ELEVEN_WEEKS,
    daysCount: DAYS_IN_WEEK * 11,
  },
  {
    id: WS_TWELVE_WEEKS,
    daysCount: DAYS_IN_WEEK * 12,
  },
];
